import {computed, ref, unref, toRef} from 'vue';
import {toBase64} from '../helpers/toBase64';
import {handleAppOctetStreamResponse} from '../helpers/docDownload';
import kebabCase from 'lodash/kebabCase';
import {getExtension} from 'mime';
import is from '@sindresorhus/is';

export const useDccsForm = (props) => {
    const busy = ref(false);

    const appendFromUrl = toRef(props, 'appendFromUrl');

    /**
     * This method transforms the VeeValidate Form's raw data to something that our api can consume.
     * @param rawData {Object} The form fields raw data.
     * @returns {Promise<{}>}
     */
    const generateFormPayload = async rawData => {
        let payload = {};

        for await (const [key, value] of Object.entries(rawData)) {
            if (value instanceof File || (Array.isArray(value) && value[0] instanceof File)) {
                payload[key] = [];

                let files = value;
                let filesArray = [];

                if (files instanceof File) {
                    filesArray.push(value);
                } else {
                    filesArray = files;
                }


                for await (const file of filesArray) {
                    const encodedFileData = await toBase64(file);
                    const fileExtension = getExtension(file.type);
                    const sanitizedFileName = kebabCase(file.name.replace(/\.[^/.]+$/, ''));
                    payload[key].push(
                        `name:${sanitizedFileName}.${fileExtension};extension:${fileExtension};${encodedFileData}`
                    );
                }
            } else {
                payload[key] = value;
            }
        }

        // Add a special parameter if needed so we can track form submissions better
        if (unref(appendFromUrl) === true) {
            payload['fromUrl'] = window.location.pathname;
        }

        return payload;
    };

    const redirectUrl = toRef(props, 'redirectUrl');
    const hasValidRedirectUrl = computed(() => {
        if (!redirectUrl.value) {
            return false;
        }

        return !!(redirectUrl.value.startsWith('/') || (is.urlString(redirectUrl.value)));
    });
    const normalizedRedirectUrl = computed(() => (hasValidRedirectUrl.value === true ? unref(redirectUrl) : null));

    const handleDownloadResponse = response => {
        handleAppOctetStreamResponse(response);
    };

    return {
        busy,
        generateFormPayload,
        hasValidRedirectUrl,
        normalizedRedirectUrl,
        handleDownloadResponse,
    };
};
